const initialValues = {
  info: {},
  products: [],
};

export default initialValues;
